<template>
<modal name="loginform-dialog"
  :adaptive="true"
  :scrollable="true"
  height="auto">
  <div class="v--modal-close-top" v-loading.fullscreen.lock="fullscreenLoading">
    <el-button @click="closeLoginformDialog"
      icon="el-icon-circle-close-outline"
      style="font-size: 2rem;"
      type="text"></el-button>
  </div>
  <div style="display: inline-block;min-width: 100%;text-align:center;">
    <div style="display: inline-block;min-width: 100%;text-align:center;">
      <p style="font-size: 140%;"> 
        <img src="/static/renew_img/bnr/mypage_top_banner_quickmail_20230222.png" style="width:90%" >
      </p>
    </div>
    <div style="padding:20px 0;font-size: 70%;">
      Yagishの<router-link id="footer-link-terms" :to="{name: 'termsPage'}" target="_blank">利用規約</router-link>、<router-link id="footer-link-terms" :to="{name: 'policyPage'}" target="_blank">個人情報の取り扱い</router-link>について<br>
      に同意の上、ログインしてください。
    </div>
    <div class="text-center">
      <login-forms />
    </div>
  </div>
</modal>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
<script>
import _ from '@/assets/lib/my-lodash'
import LoginForms from '@/components/LoginSpecialForms'
export default {
  components: {
    'login-forms': LoginForms
  },
  data: function () {
    return {
      clearLocalStorageConfirmVisible: false,
      currentFormat: {},
      formatid: '',
      previewHtml: '',
      permissionType: 1,
      isSended:false,
      fullscreenLoading:false,
      username:'',
      baite_title:'バイト',
      isAgree:false,
      email:'',
      dispSaveform:true,
      dispLoadform:false,
      confirmCode:''
    }
  },
  created : function(){
    const app = this
  },
  computed: {
    cleanedPreviewHtml: function () {
      // PDFで文字化けするやつを変換しておく
      return this.previewHtml
    }
  },
  methods: {
    openLoginformDialog: function (id, flag) {
      const app = this
      this.formatid = id
      this.$modal.show('loginform-dialog')
    },
    closeLoginformDialog: function () {
      this.$modal.hide('loginform-dialog')
      this.clearLocalStorageConfirmVisible = false
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('open-loginform-dialog', this.openLoginformDialog)
    this.$eventHub.$on('popstate', this.closeLoginformDialog)
  },
  destroyed: function () {
    this.$eventHub.$off('open-loginform-dialog', this.openLoginformDialog)
    this.$eventHub.$off('popstate', this.closeLoginformDialog)
  }
}
</script>
